export class ClientStatusModel { 
    id: number;
    clientState: string;
    color:string;
    status: boolean;
    orders:number;  
    active?: boolean;
    isExistId:boolean;
}
